module.exports = __webpack_public_path__ + "static/media/Advait.65ea6696.jpeg";